import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs/Observable";
import { AppCommonService } from "../appcommon.service";
import { AuthService } from "../auth.service";
import { GlobalService } from "../global.service";
import { Router } from "@angular/router";
import { ApiEndPoints } from "../api.endpoints";
import { forEach } from "@angular/router/src/utils/collection";
import { ISurvey, SurveyModel } from "./Survey";
import { IMailSurvey, MailSurveyModel } from "../genericpages/mailsurvey/MailSurvey";

@Injectable()
export class HomeService extends GlobalService {

  constructor(
    private http: Http,
    private cookieService: CookieService,
    private appCommonService: AppCommonService,
    private authService: AuthService,
    private router: Router
  ) {
    super(http, router);
    this.authServiceRef = this.authService;
  }
  
  public sendSurvey(survey: ISurvey): Observable<ISurvey> {    
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.SurveyEndPoint;
      return this.http.post(url, survey, options)
        // .do(data => console.log('createUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new SurveyModel();
      //model.EndPointURL = ApiEndPoints.SurveyEndPoint;
      model.Token = token.access_token;
      model.Survey = survey;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.SurveyEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  public sendMailSurvey(survey: IMailSurvey): Observable<IMailSurvey> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.MailSurveyEndPoint;
      return this.http.post(url, survey, options)
        // .do(data => console.log('createUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      //let token = this.authService.getToken();
      let model = new MailSurveyModel();
      //model.EndPointURL = ApiEndPoints.MailSurveyEndPoint;
      //model.Token = token.access_token;
      model.Survey = survey;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.MailSurveyEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.service.ts